function initCarousel() {
	if ($('.js-carousel').length) {
		$('.js-carousel').slick({
			infinite: true,
			autoplay: true,
  			autoplaySpeed: 4000,
  			speed: 1000,
  			cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
  			dots: true,
  			arrows: true,
  			pauseOnHover: false,
      prevArrow:'<a class="slick-prev"><img src="./wp-content/themes/5x5/svg/arrow-left.svg" alt="left" /></a>',
      nextArrow:'<a class="slick-next"><img src="./wp-content/themes/5x5/svg/arrow-right.svg" alt="right" /></a>',
        responsive: [
        {
          breakpoint: 1100,
          settings: {
            arrows: false,
          }
        }]
		});
    $('.js-carousel').on('breakpoint', function(){
      $(this).find('.js-async-bg').addClass('not-loaded');
      // asyncBg();
    });
	}
  if ($('.js-carousel-instagram').length) {
    $('.js-carousel-instagram').slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 2,
      autoplay: true,
      autoplaySpeed: 4000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 2,
          }
        },
        // {
        //   breakpoint: 600,
        //   settings: {
        //     slidesToShow: 2,
        //     slidesToScroll: 2
        //   }
        // },
        {
          breakpoint: 481,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
  }

  if ($('.js-carousel-partners').length) {
    $('.js-carousel-partners').slick({
      infinite: true,
      slidesToShow: 6,
      slidesToScroll: 2,
      autoplay: true,
      autoplaySpeed: 4000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 2,
          }
        },
        // {
        //   breakpoint: 600,
        //   settings: {
        //     slidesToShow: 2,
        //     slidesToScroll: 2
        //   }
        // },
        {
          breakpoint: 481,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
  }

  if ($('.js-carousel-fade').length) {
    $('.js-carousel-fade').slick({
      infinite: true,
      autoplay: true,
      autoplaySpeed: 4000,
      speed: 1000,
      fade: true,
      cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
      dots: false,
      arrows: false,
      pauseOnHover: true,
    });
  }
}